import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistorySummaryPathStatuses } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_SUMMARY_PATH_STATUSES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistorySummaryPathStatusesReturned {
	consistencyCheckHistorySummaryPathStatuses: TSelectOption<string>[];
	isLoadingConsistencyCheckHistorySummaryPathStatuses: boolean;
}

const useConsistencyCheckHistorySummaryPathStatuses = (): IUseConsistencyCheckHistorySummaryPathStatusesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_SUMMARY_PATH_STATUSES],
		queryFn: extractQueryParams(getConsistencyCheckHistorySummaryPathStatuses),
		select: (data) => nameTitleToOptionFormatted(data || []),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckHistorySummaryPathStatuses: data || [],
		isLoadingConsistencyCheckHistorySummaryPathStatuses: isInitialLoading,
	};
};

export default useConsistencyCheckHistorySummaryPathStatuses;
